// test1585
(1585 && 0);
